import React from "react";
function Mnav() {
    return (
        <nav class="navbar bg-body-tertiary" style={{ padding: "0" }}>
            <div class="container-fluid" style={{ backgroundColor: "#e0472c" }}>
                <a href="/" class="navbar-brand" style={{ color: "white" }}><img src="../../../../logo-white.png" alt="LtsGo" style={{ width: "60px", marginRight: "5px" }}></img> LtsGo</a>
            </div>
        </nav>
    );
};
export default Mnav;